import Editor from "../../Components/common/Editor";
import React, { useEffect, useState } from "react";
import { Card, Button, message } from "antd";
import trans from "./../../../Languages/Languages";
import API from "../../../API";
import CourseCatalogue from "./../../Components/courses/CourseCatalogue";
import { usePageContext } from "../../../Context/PageContext";

const CoursesCategories = () => {
  const [courseCategoryEditorHtml, setCourseCategoryEditorHtml] = useState("");
  const handleCourseCategoryEditorChange = (html) => {
    setCourseCategoryEditorHtml(html);
  };
  const [courseCatalogueData, setCourseCatalogueData] = useState([]);
  const [newCatalogueData, setNewCatalogueData] = useState([]);
  const handleAnotherCourseCatalogueAdded = () => {
    const dummyData = [
      ...courseCatalogueData,
      { image: "", title: "", courses: [], new: true },
    ];
    setCourseCatalogueData(dummyData);

    const newRecord = [
      ...newCatalogueData,
      { image: "", courses: [], title: "", new: true },
    ];
    setNewCatalogueData(newRecord);
  };

  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(true);

  const [courseCategoriesLabel, setCourseCategoriesLabel] = useState(null);
  const [courseCatalogueLabel, setCourseCatalogueLabel] = useState(null);
  const [renamingSection, setRenamingSection] = useState(null);
  const [editingSection, setEditingSection] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [showContextMenu, setShowContextMenu] = useState(false);
  const [contextMenuPos, setContextMenuPos] = useState({ x: 0, y: 0 });
    const { triggerRefresh } = usePageContext();

  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///                  Use Effect
  ////////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    setLoading(true);

    const init = async () => {
      await API.get("/admin/category")
        .then((res) => {
          setCourseCategoriesLabel(res.data.courseCategoriesLabel);
          setRenameValue(res.data.courseCategoriesLabel?.title);
          setCourseCatalogueLabel(res.data.courseCatalogueLabel);

          setCourseCatalogueData(res.data?.category);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    };

    init();

    API.get(`/admin/category/about`)
      .then((res) => {
        setCourseCategoryEditorHtml(res?.data?.about);
      })
      .catch((err) => { });
  }, [refresh]);

  ///////////////////////////////////////////////////////////////////////////////////////////////
  ///                             create new records
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const handleCreateNew = async () => {
    setLoading(true);
    if (newCatalogueData.length > 0) {
      const formData = new FormData();
      newCatalogueData.forEach((element, i) => {
        formData.append(`data[${i}][title]`, element.title);
        formData.append(`data[${i}][image]`, element.image);
      });

      await API.post("/admin/category/create", formData)
        .then((res) => {
          setNewCatalogueData([]);
          setLoading(false);
          setRefresh(!refresh);
          message.success("Created Successfully");
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const handleCategoriesAbout = () => {
    const formData = new FormData();
    formData.append("about", courseCategoryEditorHtml);

    API.post(`/admin/category/about/update`, formData)
      .then((res) => {
        message.success("Updated successfully");
      })
      .catch((err) => { });
  };

  // Hide context menu on outside click
  useEffect(() => {
    const handleClickOutside = () => {
      setShowContextMenu(false);
    };

    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  const handleRenameSubmit = async () => {
    const section = editingSection;
    const page =
      section === "courseCategoriesLabel"
        ? courseCategoriesLabel
        : section === "courseCatalogueLabel"
          ? courseCatalogueLabel
          : null;

    try {
      await API.put(`/admin/pages/slug/${page.slug}`, { title: renameValue });

      if (section === "courseCategoriesLabel") {
        setCourseCategoriesLabel((prev) => ({ ...prev, title: renameValue }));
      } else if (section === "courseCatalogueLabel") {
        setCourseCatalogueLabel((prev) => ({ ...prev, title: renameValue }));
      }

      setRenamingSection(null);
      setEditingSection(null);
      triggerRefresh();
    } catch {
      message.error("Rename failed");
    }
  };

  const handleTitleRightClick = (e, sectionKey, label) => {
    e.preventDefault();
    setContextMenuPos({ x: e.clientX, y: e.clientY });
    setShowContextMenu(true);
    setEditingSection(sectionKey);
    setRenameValue(label?.title);
  };

  const handleTitleDoubleClick = (sectionKey, label) => {
    setRenamingSection(sectionKey);
    setRenameValue(label?.title);
    setEditingSection(sectionKey);
  };

  const renderEditableTitle = (sectionKey, label, fallbackText) => (
    <div
      className="fw-600 fw-15 mb-2"
      onDoubleClick={() => handleTitleDoubleClick(sectionKey, label)}
      onContextMenu={(e) => handleTitleRightClick(e, sectionKey, label)}
    >
      {renamingSection === sectionKey ? (
        <input
          type="text"
          value={renameValue}
          autoFocus
          onChange={(e) => setRenameValue(e.target.value)}
          onBlur={handleRenameSubmit}
          onKeyDown={(e) => e.key === "Enter" && handleRenameSubmit()}
          style={{ padding: "2px 6px", fontSize: "14px" }}
        />
      ) : (
        label?.title || fallbackText
      )}
    </div>
  );

  return (
    <div className='pages-container'>
      <div className='bg-content-container'>
        <Card loading={loading} bordered={false}>
          <div className='content-wrapper'>
          {renderEditableTitle("courseCategoriesLabel", courseCategoriesLabel, trans.Coursecategories)}
            <Editor
              key='courseCategories1'
              editorHtml={courseCategoryEditorHtml}
              setEditorHtml={setCourseCategoryEditorHtml}
              handleChange={handleCourseCategoryEditorChange}
            />
            <div className='d-flex justify-content-end save-section'>
              {/* save changes */}
              <div
                onClick={handleCategoriesAbout}
                className='btn-save-section fw-500'
              >
                <span>{trans.Savesection}</span>
              </div>
            </div>
            {renderEditableTitle("courseCatalogueLabel", courseCatalogueLabel, trans.Coursecatalogue)}
            {courseCatalogueData.map((item, i) => {
              return (
                <CourseCatalogue
                  key={i}
                  index={i}
                  data={item}
                  courseCatalogueData={courseCatalogueData}
                  setLoading={setLoading}
                  refresh={refresh}
                  setRefresh={setRefresh}
                  setCourseCatalogueData={setCourseCatalogueData}
                  newCatalogueData={newCatalogueData}
                  setNewCatalogueData={setNewCatalogueData}
                />
              );
            })}
          </div>
          <div onClick={handleAnotherCourseCatalogueAdded}>
            <span className='f-12 fw-500'>
              <span className='mr-2 cursor-pointer'> {trans.AddNewSection}</span>
              <span className='f-18 fw-500 align-middle'>+</span>
            </span>
          </div>

          {newCatalogueData.length > 0 && (
            <Button
              onClick={handleCreateNew}
              className='btn-save-changes'
              type='primary'
              htmlType='submit'
            >
              {trans.Save}
            </Button>
          )}
        </Card>
        {/* Context Menu */}
        {showContextMenu && (
          <ul
            style={{
              position: "fixed",
              top: contextMenuPos.y,
              left: contextMenuPos.x,
              backgroundColor: "white",
              border: "1px solid #ccc",
              borderRadius: 4,
              listStyle: "none",
              padding: "5px 10px",
              margin: 0,
              zIndex: 1000,
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
            onClick={() => {
              setRenamingSection(editingSection);
              setShowContextMenu(false);
            }}
            onMouseLeave={() => setShowContextMenu(false)}
          >
            <li>{trans.Rename}</li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default CoursesCategories;
